import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LineSeperator from '../ui/LineSeperator';
import '../../stylings/SchoolAwards.css';

gsap.registerPlugin(ScrollTrigger);

const stats = [
  { label: 'Years of Experience', value: 34, suffix: '+' },
  { label: 'Qualified Staff', value: 150, suffix: '+' },
  { label: 'Students Enrolled', value: 3000, suffix: '+' },
  { label: 'Communication Lab', value: 3, suffix: '' },
  { label: 'CBSE Score', value: 99, suffix: '%' },
  { label: 'Awards Received', value: 25, suffix: '+' },
];

function CountUp({ end, suffix, start }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    let observer;
    const el = ref.current;
    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let current = 0;
          const step = Math.ceil(end / 60);
          const timer = setInterval(() => {
            current += step;
            if (current >= end) { setCount(end); clearInterval(timer); }
            else setCount(current);
          }, 25);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => observer?.disconnect();
  }, [end]);

  return <span ref={ref}>{count}{suffix}</span>;
}

export default function SchoolAwards() {
  return (
    <section className="school-awards-section">
      <div className="awards-bg-overlay">
        <div className="container-fluid px-5">
          <LineSeperator title="Akash Model School in Numbers" />
          <div className="awards-stats-grid">
            {stats.map((s, i) => (
              <div key={i} className="awards-stat-card">
                <div className="stat-value">
                  <CountUp end={s.value} suffix={s.suffix} />
                </div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
